export const HTTP_STATUS: { [key: string]: string } = {
    NETWORK_ERR: 'ERR_NETWORK',
    BAD_REQUEST: 'ERR_BAD_REQUEST',
    SERVER_ERR: 'ERR_BAD_RESPONSE'
};
